import React, { useMemo } from "react";
import {
  TeamOutlined,
  FileDoneOutlined,
  DollarOutlined,
  CreditCardOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { StatisticsRow, StatItem } from "../../Common/Layout";

export interface PracticeStatsRowProps {
  items: any[];
  totalRecords: number;
}

export const PracticeStatsRow: React.FC<PracticeStatsRowProps> = ({
  items = [],
  totalRecords = 0,
}) => {
  const kpiStats: StatItem[] = useMemo(() => {
    let totalFilings = 0;
    let totalInvoiced = 0;
    let totalCollected = 0;
    let totalComms = 0;

    items.forEach((item: any) => {
      const s = item.stats || {};
      totalFilings +=
        (s.ct || 0) +
        (s.vat || 0) +
        (s.cis || 0) +
        (s.sA100 || 0) +
        (s.sA800 || 0) +
        (s.sA900 || 0) +
        (s.cs || 0) +
        (s.cf || 0) +
        (s.fps || 0) +
        (s.eps || 0) +
        (s.accountsReport || 0);

      totalInvoiced += s.invoicesAmount || 0;
      totalCollected +=
        (s.receiptsAmount || 0) +
        (s.stripeTotalAmount || 0) +
        (s.goCardlessTotalAmount || 0);

      totalComms += (s.emails || 0) + (s.incoming || 0) + (s.outgoing || 0);
    });

    return [
      {
        key: "tenants",
        label: "Total Tenants",
        value: totalRecords || items.length,
        prefix: <TeamOutlined style={{ fontSize: 16, marginRight: 4 }} />,
        colorToken: "colorPrimary",
      },
      {
        key: "filings",
        label: "Submissions (Page)",
        value: totalFilings.toLocaleString("en-GB"),
        prefix: <FileDoneOutlined style={{ fontSize: 16, marginRight: 4 }} />,
        colorToken: "colorInfo",
      },
      {
        key: "invoiced",
        label: "Invoiced Gross (Page)",
        value: `£${Number(totalInvoiced).toLocaleString("en-GB", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`,
        prefix: <DollarOutlined style={{ fontSize: 16, marginRight: 4 }} />,
        colorToken: "colorSuccess",
      },
      {
        key: "collections",
        label: "Collections (Page)",
        value: `£${Number(totalCollected).toLocaleString("en-GB", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}`,
        prefix: <CreditCardOutlined style={{ fontSize: 16, marginRight: 4 }} />,
        colorToken: "colorWarning",
      },
      {
        key: "comms",
        label: "Communications (Page)",
        value: totalComms.toLocaleString("en-GB"),
        prefix: <MessageOutlined style={{ fontSize: 16, marginRight: 4 }} />,
      },
    ];
  }, [items, totalRecords]);

  return <StatisticsRow stats={kpiStats} />;
};

export default PracticeStatsRow;
